import { Image, Text, VStack } from '@chakra-ui/react';

import OutlineButton from '@/client/components/shared/buttons/OutlineButton';

interface LearnerDashboardNoDataPlaceholderProps {
  imagePath: string;
  title: string;
  helpText: string;
  buttonData?: {
    buttonCopy: string;
    buttonAction: () => void;
  };
}

export default function LearnerDashboardNoDataPlaceholder({
  imagePath,
  title,
  helpText,
  buttonData = undefined,
}: LearnerDashboardNoDataPlaceholderProps) {
  return (
    <VStack
      spacing={4}
      width="full"
      backgroundColor="neutral.0"
      border="1px solid"
      borderColor="neutral.100"
      borderRadius="16px"
      paddingY={8}
    >
      <Image src={imagePath} alt={title} />

      <VStack spacing={0} textAlign="center">
        <Text fontSize="16px" fontWeight={600} color="baseBlack">
          {title}
        </Text>

        <Text fontSize="16px" fontWeight={500} color="neutral.600">
          {helpText}
        </Text>
      </VStack>

      {buttonData && (
        <OutlineButton onClick={buttonData.buttonAction}>{buttonData.buttonCopy}</OutlineButton>
      )}
    </VStack>
  );
}
